var logo = ''
var bgColor = ''
var secondary = ''
var nombre = ''
switch(process.env.REACT_APP_CLIENT) {

    case "Exertus":
        logo = "/LogoExertus.png";
        bgColor = "#FC6923";
        secondary = "#C0C4C7";
        nombre = "Exertus"
        break;
    case "DX":
        logo = "/LogoDX.png";
        bgColor = "#06038D";
        secondary = "#06038D";
        nombre = "DX"
        break;
    case "Ximple":
        logo = "/LogoXimple.png";
        bgColor = "#004CB0";
        secondary = "#0044D0";
        nombre = "Ximple"
        break;
    default:
        logo = "/LogoExertus.png";
        bgColor = "#FC6923";
        secondary = "#C0C4C7";
        nombre = "Exertus"
}

export const logoCliente = logo
export const bgColorCliente = bgColor
export const secondaryColor = secondary
export const nombreCliente = nombre
